import { MenuItem } from '@mui/material';

interface MenuItemComponentProps {
  value: string | number;
  label: string;
}

export function BaseMenuItem({ value, label, ...otherProps }: MenuItemComponentProps) {
  return (
    <MenuItem {...otherProps} value={value}>
      {label}
    </MenuItem>
  );
}
